import React, { useState } from "react";
import Button from "../../components/common/Button";
import BgImage1 from "../../assets/shadows/subscribe_1.png";
import BgImage2 from "../../assets/shadows/subscribe_2.png";
import { subscribeEmail } from '../../api/common-api';

const SubscribeEmail = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const submit =async (e)=> {
    e.preventDefault();
    if(email){
      setLoading(true);
      try {
        await subscribeEmail(email);
        setEmail('');
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 7000);
      } catch (error) {
        setError(error?.response?.data?.toString() ?? 'An error has occured.');
      }
      finally{
        setLoading(false);
      }
    }
  }
  return (
    <form onSubmit={submit}>
    <div className="relative bg-dark rounded-3xl lg:mx-0 mx-[5vw] px-5 md:py-20 py-16">
      <div className="relative z-10 flex flex-col items-center">
        <p className="font-semibold md:text-5xl text-4xl leading-tight text-center text-white mb-8">
          Subscribe to Email Updates
        </p>
        <p className="max-w-[526px] text-base leading-6 text-gray text-center mb-8">
            Share your email address to receive hackathon updates!
        </p>
        <div className="w-full flex max-w-[454px] relative border rounded-2xl border-[#FFFFFF10] overflow-hidden">
          <input    
            value={email}
            onChange={e => {
              setEmail(e.target.value);
              if(error) setError("");
            }}
            required        
            className="w-full h-14 px-6 text-white text-base bg-transparent focus:outline-none"
            type="email"
            placeholder="Email Address"
          />
          <Button type="submit" disabled={loading} className=" hidden md:block">
            {
              loading? 'Wait...': 'Subscribe'
            }
          </Button>
        </div>
        <Button disabled={loading} type="submit" className=" block md:hidden w-full max-w-[454px] mt-4">
        {
              loading? 'Wait...': 'Subscribe'
            }
        </Button>
      </div>

      {error? <div className="text-center text-red-600 pt-5">{error}</div>: undefined }
      {success? <div className="text-center text-white pt-5">{'Subscribed successfully.'}</div>: undefined }
      
      <img
        src={BgImage1}
        alt=":( Not Found"
        className="absolute top-0 left-0"
      />
      <img
        src={BgImage2}
        alt=":( Not Found"
        className="absolute top-0 right-0"
      />
    </div>
    </form>
  );
};

export default SubscribeEmail;
